<template lang="html">
  <div id="tap-in-counter-placeholder" />
</template>

<script>
  /*eslint-disable */

  import { mapGetters } from 'vuex';

  // NOTE: importing d3 from node_modules is currently breaking webpack
  // index.html is importing it through CDN

  export default {
    data() {
      return {};
    },
    computed: {
      ...mapGetters(['getClassSummaryLD']),
    },
    mounted() {
      const d3 = window.d3version4;
      const that = this;
      let total_turns = 0;
      this.getClassSummaryLD.student_participations.forEach((s) => {
        total_turns += s.times_spoken;
      });

      const speakersCount = this.getClassSummaryLD.student_participations.filter((s) => s.times_spoken > 0).length;

      let endVal = Number(
        (total_turns / speakersCount).toFixed(2)
      );

      endVal = isNaN(endVal) ? 0 : endVal;

      const svg = d3
        .select('#tap-in-counter-placeholder')
        .append('svg')
        .attr('width', 30)
        .attr('height', 30);

      const text = svg
        .append('text')
        .attr('x', '50%')
        .attr('y', '70%')
        .attr('font-size', '16px')
        .attr('font-weight', 'bold')
        .attr('text-anchor', 'middle')
        .text('0')
        .style('fill', '#283248')
        .transition()
        .tween('text', function () {
          const selection = d3.select(this);
          const start = d3.select(this).text();
          const end = endVal;
          const interpolator = d3.interpolateNumber(start, end);

          return function (t) {
            selection.text(Math.min(interpolator(t)).toFixed(1));
          };
        })
        .duration(900);
    },
  };

  /*eslint-enable */
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  #student-name
    font-weight: bold
    font-size: 18px

  #total-time
    font-weight: bold
    font-size: 30px

  .text-minutes
    font-size: 12px
    opacity: 0

  .axis path,
  .axis line
    fill: none
    stroke: #000
    shape-rendering: crispEdges

  .bar
    fill: orange

  .solidArc
    -moz-transition: all 0.3s
    -o-transition: all 0.3s
    -webkit-transition: all 0.3s
    transition: all 0.3s

  .x.axis path
    display: none

  .d3-tip
    line-height: 1
    font-weight: bold
    padding: 12px
    background: rgba(0, 0, 0, 0.8)
    color: #fff
    border-radius: 2px
    z-index: 999
</style>



// WEBPACK FOOTER //
// tapInCounter.vue?3cc649b2